<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="form-group">
              <p style="font-size:35px">Welcome!</p>
              <p style="font-size:20px">Click <a target="_blank" href="http://premises.support.unitdynamic.com">here</a> to check out the support desk</p>
            </div>
          </div>
        </div>
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="form-group">
              <p style="font-size:35px">Message from UNIT Innovations,</p>
              <p style="font-size:20px">
                Hello {{this.$store.state.usermain.curOrg.name}}, <br/>
                <br/>
                We are deploying a new Corrections Inventory System! Below are some features <br/>
                <br/>
                1. Mobile and web based inventory system <br/>
                2. Custom Sensors, Barcode, QR Codes, or IDs for Tagging <br/>
                3. Tailored for corrections with check in, check out, issuance, and more <br/>
                4. Safe staff time and improve productivity <br/>
                5. Improve accountability, compliance, and reimbursements for quick ROI <br/>
                <br/>
                <b>If you are interested in bringing our latest offering to your facility contact your account representative for an early 2021 existing client discount. </b><br/>
                <br/>
                If you need any other technology solutions reach out to us to see how we can help.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Home.vue?03db0292